import { addBreadcrumb, captureException } from '@sentry/browser';

import { AnalyticsPlatform } from '../types';

export class GTMPlatform implements AnalyticsPlatform {
  private static countriesCodeBlacklist = ['IR'];
  private static instance: GTMPlatform | null = null;

  private currentCountry: string = '';

  constructor() {
    if (GTMPlatform.instance) {
      return GTMPlatform.instance;
    }
    GTMPlatform.instance = this;
  }

  isGtmLoaded() {
    window.dataLayer = window.dataLayer || [];
    const gtmStartedEvent = window.dataLayer.find((element) => element['gtm.start']);
    if (!gtmStartedEvent) {
      return false; // Not even the GTM inline config has executed
    } else if (!gtmStartedEvent['gtm.uniqueEventId']) {
      addBreadcrumb({
        message: 'Main GTM js is not loaded (likely AdBlock, NoScript, URL blocking etc.',
      });
      return false;
    }
    return true; // GTM is fully loaded and working
  }

  waitForGTM = <T>(callback: () => void, maxWait = 10000, eventName: string, eventPayload: T) => {
    let done = false;
    let waited = 0;
    const interval = 50;

    const check = () => {
      if (done) return;
      const isGTMReady = this.isGtmLoaded();

      if (isGTMReady || waited >= maxWait) {
        clearInterval(timer);
        done = true;

        if (waited >= maxWait) {
          addBreadcrumb({
            message: `Couldn't push Event: ${eventName} waited for ${waited}ms`,
            category: 'dataLayer',
            data: eventPayload as object,
            level: 'error',
          });
          captureException(
            new Error(`Couldn't push Event: ${eventName} with maxWait: ${maxWait}ms`),
          );
        }

        callback();
      }

      waited += interval;
    };

    const timer = setInterval(check, interval);
  };

  public setCountry(country: string): void {
    this.currentCountry = country;
  }

  public async sendEvent<T>(eventName: string, eventPayload: T) {
    if (GTMPlatform.countriesCodeBlacklist.includes(this.currentCountry)) return;
    this.waitForGTM(
      () => {
        window.dataLayer.push({ event: eventName, ...eventPayload });
      },
      10000,
      eventName,
      eventPayload,
    );
  }
  // TODO: когда подключим Partytown, тогда будет работать
  // if (typeof window !== 'undefined' && window.dataLayer) {
  //   // Прямой вызов dataLayer.push - будет перенаправлен через Partytown
  //   window.dataLayer.push({
  //     event: eventName,
  //     ...eventPayload,
  //   });
  //   console.debug(`GTM event via Partytown: ${eventName}`, eventPayload);
  // } else {
  //   // Fallback на TagManager если dataLayer не найден
  //   TagManager.dataLayer({ dataLayer: { event: eventName, ...eventPayload } });
  // }
}
